module.exports = __webpack_public_path__ + "img/hnhk.78d0aa14.webp";